import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import uiConf from "../../config/uiConf";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import ActionButtonLayout from "../layout/ActionButtonLayout";
import ExcelIcon from "../presentation/ExcelIcon";

import apiClient from "../../lib/common/apiClient";

function EguSelfInspectionFileDownloadButton(props) {
    const { id, selfInspectionId, ...others } = props;

    const { t } = useTranslation();

    const url = `/api/EguSelfInspectionFileDownload/${selfInspectionId}`;
    const targetFileName = `검사성적서_${selfInspectionId}.xlsx`;

    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const onSuccess = (result) => {
        setNotification({
            severity: "success",
            msg: t("success.fileDownloadSuccess"),
            open: true,
        });
    };
    const onFailure = (reason) => {
        setNotification({
            severity: "error",
            msg: t("error.fileDownloadFailure", { reason: reason.response ? reason.response.data : reason }),
            open: true,
        });
    };

    const onCloseNotification = () => {
        setNotification((notification) => {
            return { ...notification, open: false };
        });
    };

    const doHandleFileStream = (result) => {
        const blob = new Blob([result.data]);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = targetFileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
    };

    const fileDownload = () => {
        apiClient
            .get(url, { responseType: "blob" }) // Note : responseType := "blob" !!
            .then((result) => {
                doHandleFileStream(result);
                onSuccess(result);
            })
            .catch((reason) => onFailure(reason));
    };

    return (
        <>
            <ActionButtonLayout
                id={id + "self-inspection-file-dowwnload-button"}
                startIcon={<ExcelIcon />}
                onClick={fileDownload}
                {...others}
            >
                {t("buttonName.eguSelfInspectionDownload")}
            </ActionButtonLayout>
            <Snackbar
                open={notification.open && notification.severity !== "success"}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert onClose={onCloseNotification} variant="filled" severity={notification.severity}>
                    {notification.msg}
                </Alert>
            </Snackbar>
        </>
    );
}

export default EguSelfInspectionFileDownloadButton;
